import { render, staticRenderFns } from "./treasureBox.vue?vue&type=template&id=31e87def&scoped=true&"
import script from "./treasureBox.vue?vue&type=script&lang=js&"
export * from "./treasureBox.vue?vue&type=script&lang=js&"
import style0 from "./treasureBox.vue?vue&type=style&index=0&id=31e87def&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e87def",
  null
  
)

export default component.exports